var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Card, CardContent, CardHeader, Divider, Grid } from '@mui/material';
var DashboardPanel = function (_a) {
    var title = _a.title, children = _a.children, _b = _a.gridProps, gridProps = _b === void 0 ? {} : _b;
    return (React.createElement(Grid, __assign({}, gridProps, { item: true }),
        React.createElement(Card, { variant: "outlined" },
            React.createElement(CardHeader, { title: title, sx: {
                    '&.MuiCardHeader-root ': {
                        padding: '24px',
                    },
                    '& .MuiCardHeader-content ': {
                        fontWeight: 'bold',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                    },
                } }),
            React.createElement(Divider, null),
            React.createElement(CardContent, { sx: {
                    maxHeight: 500,
                    overflow: 'scroll',
                } }, children))));
};
export default DashboardPanel;
